import { Component, OnInit, Input } from '@angular/core';
import { totalSales } from 'src/app/model/installation/ventes.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

const NB_MOIS = 12;
const NB_JOUR = 31;


@Component({
  selector: 'app-installation-sales',
  templateUrl: './installation-sales.component.html',
  styleUrls: ['./installation-sales.component.scss']
})



export class InstallationSalesComponent implements OnInit {

  public ventes !: any;
  public totalVentes !: totalSales[];
  public jour !: number;
  public tJour: Array<number> = [];
  public nbMois !: number;
  public listeMois: Array<string> = ["Janv.", "Fév.", "Mars", "Avr.", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."];
  public tDateHeader: Array<any> = [];
  public countYear: number = 0;
  public countMonth: number = 0;
  public now: Date = new Date();
  public startYear !: number;
  public startMonth !: number;
  public monthCount !: number;
  public tYearMonth: Array<any> = [];
  public total: any = [];
  public moyenne: any = [];
  public sommeCA: any = [];
  public nbValues: any = [];
  public max !: number;
  public indexes !: any;

  @Input() installation !: any;
  constructor(private service: InstallationsService) { }
  ngOnInit(): void {
    this.computeDateHeader();
    this.computeDate();
    this.getDaysArray();
    if (this.installation) {
      this.getTotalSalesData(this.installation.id_backup);
    }
  }


  public computeDate(): number {
    let past = new Date(this.now.getFullYear() + this.countYear, this.now.getMonth() - 12, 1);
    this.monthCount = 12;
    this.startMonth = this.now.getMonth() + 2;
    this.startYear = past.getFullYear();
    this.getYearAndMonthData();
    this.getOneMachineSalesData();
    return this.startYear;
  }


  public getYearAndMonthData(): Array<any> {
    let date = new Date();
    this.tYearMonth = [];
    for (let i = 0; i < NB_MOIS; i++) {
      this.tYearMonth.push({ year: date.getFullYear() + this.countYear, month: (date.getMonth() + 1) });
      date.setMonth((date.getMonth()) - 1);
    }
    return this.tYearMonth.reverse();
  }


  public computeDateHeader(): Array<any> {
    let date = new Date();
    this.tDateHeader = [];

    date.setFullYear(date.getFullYear() + this.countYear, date.getMonth());
    date.setMonth(date.getMonth() + this.countMonth);

    for (let i = 0; i < NB_MOIS; i++) {
      this.tDateHeader.push(this.listeMois[date.getMonth()] + ' ' + date.getFullYear());
      date.setMonth(date.getMonth() - 1);
    }
    this.tDateHeader.reverse();
    return this.tDateHeader;
  }

  // CHANGE YEAR --------------------------------------------------

  /**
   * @author MARCONNET François
   * Method called when user clicks on 'année suivante'
   */
  public onClickYearUp() {
    this.total = [];
    this.moyenne = [];
    this.sommeCA = [];
    this.countYear++;
    this.computeDateHeader();
    this.computeDate();
  }

  /**
   * @author MARCONNET François
   * Method called when user clicks on 'année précédente'
   */
  public onClickYearDown() {
    this.total = [];
    this.moyenne = [];
    this.sommeCA = [];
    this.countYear--;
    this.computeDateHeader();
    this.computeDate();
  }


  // CHANGER LA VALEUR DES DONNEES RECUES EN FONCTION DE LA DATE ---------------------------------

  /**
   * @author MARCONNET François
 * Retrieve the sales data of the machine
 * @param startMonth 
 * @param startYear 
 * @param monthCount 
 * @param idMachine 
 * @param idBackUp 
 */
  public getOneMachineSalesData() {
    if (this.installation) {
      this.service.getSalesData(this.startMonth, this.startYear, this.monthCount, this.installation.id_machine, this.installation.id_backup).subscribe((ventes) => {
        this.ventes = ventes;
        this.replaceNegativeValues(ventes);
        this.computeSums(ventes);
      })
    }
  }


  // TaBLE TOTAL : DONE ---------------------------------------------------------------

  /**
   * Retrieve the total values of sales
   * @author MARCONNET François
   * @param id 
   */
  public getTotalSalesData(id: any) {
    this.service.getTotalSalesData(this.installation.id_backup)
      .subscribe((totalVentes) => {
        this.totalVentes = totalVentes;
      });
  }

  /**
   * Creating an array containing number 1 to 31 in order to display it in the table as the number of the day.
   * @author MARCONNET François
   */
  public getDaysArray() {
    for (let i = 0; i < NB_JOUR; i++) {
      this.tJour.push(i);
    }

  }

  // Remplacer toutes les valeurs à -1 (c'est-à-dire les ventes futures, ou les jours depuis l'arrêt du DAP) par null, afin de ne pas biaiser le calcul de(s) moyenne(s)
  public replaceNegativeValues(ventes: any) {
    for (let i = 0; i < NB_MOIS; i++) {
      for (let j = 0; j < NB_JOUR; j++) {

        if (ventes[this.tYearMonth[i].year]) {

          if (ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes[j] === -1) {
            ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes[j] = null;
          }

          if (ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ca[j] === -1) {
            ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ca[j] = "0";
          }
        }

      }
    }
  }

  /**
   * Arrondir les valuers à 2 chiffres après la virgule
   * @author MARCONNET François
   * @param value 
   */
  public roundValues(value: any) {
    for (let i = 0; i < value.length; i++) {
      value[i] = value[i].toFixed(2);
    }
  }


  /**
 * Effectuer calcul de sommes 
 * @author MARCONNET François
 * @param ventes 
 */
  public computeSums(ventes: any) {
    const reducer = (previousValue: any, currentValue: any) => previousValue + currentValue;
    const reducerString = (previous: string, current: string) => parseFloat(previous) + parseFloat(current);

    for (let i = 0; i < NB_MOIS; i++) {

      if (ventes[this.tYearMonth[i].year]) {

        this.nbValues[i] = ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes;
        let nbJours = ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes.length;

        // S'il s'agit du mois en cours : prendre seulement comme longueur pour la moyenne, le nombre de jours passés.  
        for (let j = 0; j < NB_JOUR; j++) {
          if (ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes[j] !== null) {
            this.nbValues[i] = ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes;
            var newNbValues = this.nbValues[i].filter(function (el: any) {
              return el != null;
            })
            nbJours = newNbValues.length;
          }

        }

        this.total.push(ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes.reduce(reducer));
        this.moyenne.push(ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes.reduce(reducer) / nbJours);
        this.sommeCA.push(ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ca.reduce(reducerString));

      }

    }

    this.roundValues(this.moyenne);
    this.roundValues(this.sommeCA);
    this.bestOfMonth(this.ventes);

  }

  /**
   * Attribute a special class for the highest values 
   */
  public bestOfMonth(ventes: any) {
    for (let i = 0; i < 12; i++) {

      if (ventes[this.tYearMonth[i].year]) {

        let orderTable = Object.assign([], ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].ventes);
        for (let j = 0; j < NB_JOUR; j++) {
          orderTable.sort(function (a: any, b: any) {
            if (a < b)
              return 1;
            else if (a > b)
              return -1;
            else return 0;
          });


          ventes[this.tYearMonth[i].year][this.tYearMonth[i].month].bestOfMonth = orderTable[0];
        }
      }

    }
  }




}

